
export const ASYNC_OPEN_INTERNATIONAL_FETCH = 'ILD_InternationalRepTools/ASYNC_OPEN_INTERNATIONAL_FETCH';
export const ASYNC_OPEN_INTERNATIONAL_FETCH_SUCCESS = 'ILD_InternationalRepTools/ASYNC_OPEN_INTERNATIONAL_FETCH_SUCCESS';
export const ASYNC_OPEN_INTERNATIONAL_FETCH_FAILED = 'ILD_InternationalRepTools/ASYNC_OPEN_INTERNATIONAL_FETCH_FAILED';
